// extracted by mini-css-extract-plugin
export default {"rightBtn":"styles_rightBtn__liPJB","searchInput":"styles_searchInput__ZgfPi"};